<template lang="html">
  <!--	TabBar-->
  <div class="benefits">
    <NavBar
      titleTranslationPath="benefitsOverview.title"
      location="location"
      favorites="favorites"
      preferences="preferences"
      commune="commune"
    />
    <Banner :useTriggerRequestReview="true" />
	<div class="communes-selector" v-if="scopeOptions.length > 1">
        <SelectField
            identifier="scope-selector"
            label="locationOptions.commune.select"
            v-model="scopeSelected"
            :options="scopeOptions"
            :is-mandatory="false"
          >
        </SelectField>
	</div>
    <div class="content">
      <div class="search" v-if="pagedata && pagedata.isSearching">
        <div class="searchbox">
          <font-awesome-icon class="searchbox-icon" icon="search" />
          <input type="text" placeholder="" />
        </div>
        <Button class="searchbutton" center="center" :path="benefitsOverview.button.search"></Button>
      </div>
      <NewTranslation
        class="headline"
        path="benefitsOverview.headline"
        :params="{ commune: currentLocation && currentLocation.title }"
      ></NewTranslation>
      <div class="benefit-list">
        <router-link
          :to="{
            name: $namedRoutes.benefitsCategory,
            query: {
              categoryName: category.name,
			  scopeSelected: scopeSelected
            },
          }"
          class="benefit-entry"
          v-for="(category, index) in getBenefitCategoriesByName"
          :key="index"
        >
          <img class="benefit-image" :src="getCategoryImageUrl(category)" />
          <div class="benefit-info">
            <div class="benefit-amount">{{ category.count }}</div>
            <div class="benefit-name">{{ category.name }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <TabBar />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Banner from '@/components/Banner.vue';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import RemoteAssets from '@/app/utils/RemoteAssets';
import SelectField from '../form/SelectField.vue';
import i18next from 'i18next';

export default {
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Banner,
    Button,
	SelectField
  },
  data() {
    return {
		scopeSelected: 'init'
    };
  },  
  props: ['pagedata'],
  methods: {
    getCategoryImageUrl(category) {
      return RemoteAssets.benefitCategoryImageUrl(category.image);
    },
  },
  computed: {
    ...mapGetters(['currentLocation', 'benefits', 'benefitCategories']),
	getBenefitCategoriesByName() {
		// console.log("This benefitCategories", this.benefitCategories);
		const categoriesByName = {}
		for (let ind1 = 0; ind1 < this.benefitCategories.length; ind1++) {
			const benefitCategory = this.benefitCategories[ind1];
			if (benefitCategory.benefitCommuneId == this.scopeSelected || this.scopeSelected == 'all') {
				if (!categoriesByName.hasOwnProperty(benefitCategory.name)) {
					categoriesByName[benefitCategory.name] = {
						name: benefitCategory.name,
						image: benefitCategory.image,
						count: benefitCategory.count
					};
				} else {
					categoriesByName[benefitCategory.name].count += benefitCategory.count;
				}
			}
		}
		return categoriesByName;
	},
	scopeOptions() {
		const categoryCommunes = {};
		for (let ind2 = 0; ind2 < this.benefitCategories.length; ind2++) {
			const benefitCategory = this.benefitCategories[ind2];
			categoryCommunes[benefitCategory.benefitCommuneId] = benefitCategory.benefitCommune;
		}
		const communeKeys = Object.keys(categoryCommunes);

		let resultCommunes = communeKeys.map((communeKey) => {
			return {value: communeKey, label: categoryCommunes[communeKey]};
		});
		resultCommunes = [{value: "all", label: i18next.t('locationOptions.option.all')}, ...resultCommunes];
		if (this.scopeSelected == 'init' && this.currentLocation.id > 0) {
			// const optionFound = resultCommunes.some((element) => element.value == this.currentLocation.id);
			// if(optionFound) {
			// 	this.scopeSelected = this.currentLocation.id;
			// } else {
				this.scopeSelected = 'all';
			// }
		}
		return resultCommunes;
	}
  },
};
</script>

<style lang="sass" scoped>
.benefits
	padding-bottom: 100px
	.communes-selector
		margin-top: 10px
.content
	padding: 20px

.search
	padding-bottom: 20px
	margin-bottom: 20px
	border-bottom: 1px solid #eee
	.searchbox
		position: relative
		border-radius: 10px
		background: #fff
		&-icon
			position: absolute
			width: 20px
			height: 20px
			color: #454F63
			margin: 15px 20px
			top: 3px
		input
			border-radius: 10px
			height: 100%
			padding: 15px 15px 15px 55px
			font-size: 1.25rem
			border: 1px solid #ccc
	.searchbutton
		margin-top: 20px

.headline
	font-size: 1.9rem
.benefit
	// &-list
		// margin-top: 20px
	&-entry
		display: block
		height: 125px
		position: relative
		background-size: cover
		background-position: center center
		margin-top: 20px
		&[data-category="restaurant"]
			background-image: url(~@/assets/images/benefit-restaurants.jpeg)
		&[data-category="event"]
			background-image: url(~@/assets/images/benefit-konzerte.jpg)
		&[data-category="theater"]
			background-image: url(~@/assets/images/benefit-theater.jpg)
		&[data-category="kids"]
			background-image: url(~@/assets/images/benefit-kids.jpeg)
		&[data-category="sport"]
			background-image: url(~@/assets/images/benefit-sport.jpg)
	&-image
		width: 100%
		height: 100%
		object-fit: cover
		object-position: center center
		background-color: #ccc
	&-info
		position: absolute
		left: 0
		bottom: 0
		opacity: .9
		display: flex
		color: #fff
	&-amount
		display: flex
		width: 40px
		height: 40px
		justify-content: center
		align-items: center
		background-color: #DE3D36
	&-name
		min-width: 120px
		padding: 0 10px
		display: flex
		align-items: center
		background-color: #1DB2D1
</style>
